import type { RouteRecordRaw } from 'vue-router'

export const routes: RouteRecordRaw[] = [
	{
		path: '/mail/schreiben',
		name: 'mail-dialog-new',
		components: {
			default: () => import('./MailCreateView.vue'),
		},
	},
	{
		path: '/mail/dialoge/:dialogId',
		name: 'mail-dialog-detail',
		components: {
			default: () => import('./MailDialogDetail.vue'),
		},
	},
]
